<script setup lang="ts">
const routes = reactive([
  { link: `/`},
  { link: `/projects`},
  { link: `/achievements`},
  { link: `/contact`},
])
</script>

<template>
  <div class="bg-eggplant-950 h-screen">
    <h2 class="font-bold text-center text-4xl text-[#8b5cf6]">
      {{($i18n.locale === `el`) ? `Μενού` : `Menu`}}
    </h2>
    <div class="flex flex-col items-center w-screen mt-5 bg-egplant-950">
      <RouterLink v-for="(rout,id) in routes" :key="id" :to="rout.link" active-class="text-pink-300 bg-white "  class="hover:text-pink-300 transition-all ease-in duration-200 w-screen py-3 text-center text-lg font-semibold after:block after:h-0.5 hover:after:w-[100%] after:w-[0%] after:bg-pink-300 after:transition-all after:ease-in after:duration-200" >
        {{ $t(`home.menu.title${id+1}`)}}
      </RouterLink>
    </div>
  </div>
</template>
